<template>
  <div :class="$vuetify.breakpoint.mdAndDown ? 'pt-0 pb-4' : 'pb-4'" class="game-menu">
    <div>
      <!-- mobile view gametype card   -->
      <v-row no-gutters id="game-menu-full" class="game-menu-wrapper pb-2 hidden-md-and-up game-menu-row">
        <v-col cols="12" class="d-flex pt-3">
          <!-- jackpot games          -->
          <div class="mx-auto pl-3" v-if="currentCurrency.toUpperCase() == 'BDT'">
            <v-card
              text
              :ripple="false"
              depressed
              :class="['game-menu-button font-weight-bold', [$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'], [dActiveGameType === 'jackpotGames' ? 'selected' : '']]"
              @click="selectGameType('jackpotGames', -2)"
            >
              <div class="game-menu-image" :style="`--src: url('/static/svg/gameTabHolder/jackpot.svg')`">
                <img :url="`/static/svg/mobileMenu/homepageHot.png`" class="side-menu-icon" />
              </div>
              <div class="game-menu-title">{{ $t(`label.jackpotGames`) }}</div>
            </v-card>
          </div>

          <!-- homepage hot games          -->
          <div class="mx-auto" v-if="this.storageHomepageHotGames != ''">
            <v-card
              text
              :ripple="false"
              depressed
              :class="['game-menu-button font-weight-bold', [$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'], [dActiveGameType == 'homepageHot' ? 'selected' : '']]"
              @click="selectGameType('', -1)"
            >
              <div class="game-menu-image" :style="`--src: url('/static/svg/gameTabHolder/homepageHot.svg')`">
                <img :url="`/static/svg/mobileMenu/homepageHot.png`" class="side-menu-icon" />
              </div>
              <div class="game-menu-title">{{ $t(`label.hot`) }}</div>
            </v-card>
          </div>

          <!-- homepage featured games          -->
          <div class="mx-auto" v-if="this.storageHomepageFeaturedGames != ''">
            <v-card
                text
                :ripple="false"
                depressed
                :class="['game-menu-button font-weight-bold', [$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'], [dActiveGameType == 'homepageFeatured' ? 'selected' : '']]"
                @click="selectGameType('homepageFeatured', -3)"
            >
              <div class="game-menu-image" :style="`--src: url('/static/svg/gameTabHolder/homepageFeatured.svg')`">
                <img :url="`/static/svg/mobileMenu/homepageFeatured.png`" class="side-menu-icon" />
              </div>
              <div class="game-menu-title">{{ $t(`label.featured`) }}</div>
            </v-card>
          </div>

          <!--  game types       -->
          <div class="mx-auto" v-for="(gameType, index) in storageGameProviderType" :key="gameType.type" @click="selectGameType(gameType, index)">
            <v-card
              text
              :ripple="false"
              depressed
              @click="selectGameType(gameType, index)"
              :class="['game-menu-button font-weight-bold', [$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'], [dActiveGameType == gameType.type ? 'selected' : '']]"
            >
              <!--        <img :src="`/static/svg/gameTabHolder/${gameType.type}.svg`" class="side-menu-icon game-menu-image" />-->
              <div class="game-menu-image" :style="`--src: url('/static/svg/gameTabHolder/${gameType.type}.svg')`">
                <img :url="`/static/svg/mobileMenu/${gameType.type}.png`" class="side-menu-icon" />
              </div>
              <div class="game-menu-title">{{ $t(`label.${gameType.type}_short`) }}</div>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <!--      <v-divider></v-divider>-->
      <!--  mobile view jackpost tab's hot games card    -->
      <v-row class="mt-0 hidden-md-and-up mobile-provider-card-row left-right-gap" v-if="dActiveGameType === JackPotGames && jackpotPrize !== null && currentCurrency.toUpperCase() == 'BDT'">
        <v-col cols="12" class="jackpotImg-padding">
          <v-img src="/static/image/homepage/jackpot_background_en.jpg" width="100%" class="position-relative" @click="navigateToJiliSLot()">
            <div class="jackpot_container">
              <v-row no-gutters class="justify-space-around align-end">
                <v-col cols="3">
                  <v-img src="/static/image/homepage/mini_box.png" width="100%" class="imgBox">
                    <span class="text-center white--text font-weight-bold miniText">{{ miniJackpot | floatParser }}</span>
                  </v-img>
                </v-col>
                <v-col cols="4">
                  <v-img src="/static/image/homepage/grand_box.png" width="100%" class="imgBox">
                    <span class="text-center white--text grandText font-weight-bold">{{ grandJackpot | floatParser }}</span>
                  </v-img>
                </v-col>
                <v-col cols="3">
                  <v-img src="/static/image/homepage/major_box.png" width="100%" class="imgBox">
                    <span class="text-center white--text font-weight-bold majorText">{{ majorJackpot | floatParser }}</span>
                  </v-img>
                </v-col>
              </v-row>
            </div>
          </v-img>
        </v-col>
        <v-col cols="12">
          <v-row class="new-gametab-padding ld-gap">
            <v-col
              class="mobile-provider-card-item"
              :class="`gT_${HomePageHotString}`"
              v-for="(hotGames, i) in storageJackpotGames"
              :key="hotGames.code"
              @click="!isGameMaintenance(hotGames.type, hotGames.provider) ? launchGame(hotGames, false) : {}"
            >
              <v-img
                :src="hotGames.imageCdn == null ? `${mediaUrl}/game_icons/en/${hotGames.provider}/${hotGames.code}_${hotGames.id}.jpg` : `${hotGames.imageCdn}`"
                class="game-banner-img"
                :class="['homepageHot_img']"
                cover
                :aspect-ratio="BanneAspRatio"
              >
                <v-overlay v-if="isGameMaintenance(hotGames.type, hotGames.provider)" absolute opacity="0.8" class="gameMaintenanceOverlay">
                  <label class="yellow--text text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
                </v-overlay>
                <img src="/static/image/other/hot-icon.png" class="img-hot-home pos_right_top" />
              </v-img>
              <!--        <span v-if="dActiveGameType == 'rng'" class="rng_providerLabel">{{ $t(`label.custom_${provider.providerCode}`) }}</span>-->
            </v-col>
          </v-row>
        </v-col>

        <div id="autoFillEle1" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
        <div id="autoFillEle2" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
      </v-row>

      <!--  mobile view homepage hot games card    -->
      <v-row class="mt-0 hidden-md-and-up mobile-provider-card-row left-right-gap" v-else-if="dActiveGameType == HomePageHotString">
        <v-col cols="12">
          <v-row class="new-gametab-padding ld-gap">
            <v-col
              class="mobile-provider-card-item"
              :class="`gT_${HomePageHotString}`"
              v-for="(hotGames, i) in storageHomepageHotGames"
              :key="hotGames.code"
              @click="!isGameMaintenance(hotGames.type, hotGames.provider) ? launchGame(hotGames, false) : {}"
            >
              <v-img
                :src="hotGames.imageCdn == null ? `${mediaUrl}/game_icons/en/${hotGames.provider}/${hotGames.code}_${hotGames.id}.jpg` : `${hotGames.imageCdn}`"
                class="banner-img"
                :class="['homepageHot_img']"
                cover
                :aspect-ratio="BanneAspRatio"
              >
                <v-overlay v-if="isGameMaintenance(hotGames.type, hotGames.provider)" absolute opacity="0.8" class="gameMaintenanceOverlay">
                  <label class="yellow--text text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
                </v-overlay>
                <img src="/static/image/other/hot-icon.png" class="img-hot-home pos_right_top" />
              </v-img>
              <!--        <span v-if="dActiveGameType == 'rng'" class="rng_providerLabel">{{ $t(`label.custom_${provider.providerCode}`) }}</span>-->
            </v-col>
          </v-row>
        </v-col>

        <div id="autoFillEle1" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
        <div id="autoFillEle2" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
      </v-row>

      <!--  mobile view homepage featured games card    -->
      <v-row class="mt-0 hidden-md-and-up mobile-provider-card-row left-right-gap" v-else-if="dActiveGameType == HomePageFeaturedString">
        <v-col cols="12">
          <v-row class="new-gametab-padding ld-gap">
            <v-col
                class="mobile-provider-card-item"
                :class="`gT_${HomePageHotString}`"
                v-for="(featuredGames, i) in storageHomepageFeaturedGames"
                :key="featuredGames.code"
                @click="!isGameMaintenance(featuredGames.type, featuredGames.provider) ? launchGame(featuredGames, false) : {}"
            >
              <v-img
                  :src="featuredGames.imageCdn == null ? `${mediaUrl}/game_icons/en/${featuredGames.provider}/${featuredGames.code}_${featuredGames.id}.jpg` : `${featuredGames.imageCdn}`"
                  class="banner-img"
                  :class="['homepageHot_img']"
                  cover
                  :aspect-ratio="BanneAspRatio"
              >
                <v-overlay v-if="isGameMaintenance(featuredGames.type, featuredGames.provider)" absolute opacity="0.8" class="gameMaintenanceOverlay">
                  <label class="yellow--text text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
                </v-overlay>
              </v-img>
            </v-col>
          </v-row>
        </v-col>

        <div id="autoFillEle1" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
        <div id="autoFillEle2" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
      </v-row>

      <!-- mobile view game providers card   -->
      <v-row
        no-gutters
        v-else
        class="mt-0 hidden-md-and-up mobile-provider-card-row"
        style="padding-bottom: 10px"
        :class="[
          ['table', 'fishing', 'sb', 'cricket', 'ld', 'rng', 'crash', 'fastgames'].includes(dActiveGameType) ? 'ld-gap' : '',
          ['cricket', 'table', 'ld'].includes(dActiveGameType) ? 'game-warpper' : '',
        ]"
      >
        <v-col
          class="mobile-provider-card-item"
          :class="`gT_${dActiveGameType}`"
          v-for="(provider, i) in gameContainer1.providers"
          :key="provider.providerCode"
          @click="!isGameMaintenance(gameContainer1.type, provider.providerCode) ? accessGame(gameContainer1.type, provider.providerCode) : {}"
        >
          <!--          <v-img-->
          <!--            :src="'/static/image/mobileBanner/' + dActiveGameType + '_' + provider.providerCode.toLowerCase() + '.jpg'"-->
          <!--            class="banner-img"-->
          <!--            :aspect-ratio="dActiveGameType == 'ld' ? ldAspRatio : dActiveGameType == 'rng' ? 1 / 1 : 0"-->
          <!--          >-->
          <!--            <v-overlay v-if="isGameMaintenance(gameContainer1.type, provider.providerCode)" absolute opacity="0.8" class="gameMaintenanceOverlay">-->
          <!--              <label class="yellow&#45;&#45;text text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>-->
          <!--            </v-overlay>-->
          <!--          </v-img>-->

          <!--          -->
          <v-img
            :src="
              dActiveGameType === 'cricket'
                ? `${mediaUrl}/menu/${dActiveGameType}/${provider.providerCode.toLowerCase()}_new.png`
                : dActiveGameType === 'rng' ||
                  dActiveGameType === 'crash' ||
                  dActiveGameType === 'ld' ||
                  dActiveGameType === 'table' ||
                  dActiveGameType === 'sb' ||
                  dActiveGameType === 'fishing' ||
                  dActiveGameType === 'fastgames'
                ? `${mediaUrl}/menu/${dActiveGameType}/${provider.providerCode.toLowerCase()}_new.png`
                : `${mediaUrl}/mobileBanner/${dActiveGameType}_${provider.providerCode.toLowerCase()}.jpg`
            "
            class="banner-img"
            :class="[dActiveGameType == 'fastgames' ? 'sqrBox_img' : '']"
            contain
            :aspect-ratio="BanneAspRatio"
          >
            <v-overlay v-if="isGameMaintenance(gameContainer1.type, provider.providerCode)" absolute opacity="0.8" class="gameMaintenanceOverlay">
              <label class="yellow--text text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
            </v-overlay>
            <img src="/static/image/other/hot-icon.png" class="img-hot-home pos_right_top" v-if="isHotProvider(provider.providerCode)" />
            <img src="/static/image/other/new_icon.png" class="img-new-home pos_right_top" v-if="isNewProvider(provider.providerCode)" />
          </v-img>
          <!--          <span v-if="dActiveGameType == 'rng'" class="rng_providerLabel">{{ $t(`label.custom_${provider.providerCode}`) }}</span>-->

          <!--          -->
          <!--          <v-img src="/static/image/banner/downloadClient/bb88_downloadnow_appbanner_mobile.jpg" class="hidden-md-and-up banner-img" ></v-img>-->

          <!--                  {{ provider.providerCode.toUpperCase() }}-->
        </v-col>
        <div
          id="autoFillEle1"
          class="mobile-provider-card-item gT_rng"
          v-if="dActiveGameType == 'rng' || dActiveGameType == 'crash' || dActiveGameType == 'fishing' || dActiveGameType == 'homepageHot' || dActiveGameType == 'fastgames'"
          style="max-height: 0px !important"
        >
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
        <div
          id="autoFillEle2"
          class="mobile-provider-card-item gT_rng"
          v-if="dActiveGameType == 'rng' || dActiveGameType == 'crash' || dActiveGameType == 'homepageHot' || dActiveGameType == 'fastgames'"
          style="max-height: 0px !important"
        >
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
        <div
          id="autoFillEle3"
          class="mobile-provider-card-item gT_rng"
          v-if="dActiveGameType == 'rng' || dActiveGameType == 'crash' || dActiveGameType == 'fishing' || dActiveGameType == 'homepageHot' || dActiveGameType == 'fastgames'"
          style="max-height: 0px !important"
        >
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
        <div
          id="ldAutoFillEle4"
          class="mobile-provider-card-item gT_ld"
          v-if="dActiveGameType == 'ld' || dActiveGameType == 'table' || dActiveGameType == 'homepageHot'"
          style="max-height: 0px !important"
        >
          <v-img max-height="0" class="banner-img"></v-img>
        </div>
      </v-row>
    </div>

    <!-- desktop view hotgame   -->
    <v-row
      no-gutters
      class="mt-0 hidden-sm-and-down mobile-provider-card-row d-flex justify-start align-center"
      v-if="dActiveGameType == HomePageHotString && !$vuetify.breakpoint.smAndDown"
      style="gap: 2.2%"
    >
      <v-col cols="12" class="title_hotGameDesktop">
        {{ $t(`label.hotGames`) }}
      </v-col>
      <v-row no-gutters class="align-center" style="width: 100%">
        <v-col class="desktop-provider-card-item pt-3" :class="`gT_${HomePageHotString}`" v-for="(hotGames, i) in storageHomepageHotGames" :key="hotGames.code">
          <v-col class="pa-0" style="width: 95%">
            <v-col cols="12" class="pa-0">
              <v-img
                :src="hotGames.imageCdn == null ? `${mediaUrl}/game_icons/en/${hotGames.provider}/${hotGames.code}_${hotGames.id}.jpg` : `${hotGames.imageCdn}`"
                class="game-banner-img"
                :class="['homepageHot_img']"
                cover
                :aspect-ratio="BanneAspRatio"
              >
                <v-overlay v-if="!isGameMaintenance(hotGames.type, hotGames.provider)" absolute opacity="0" class="play-overlay">
                  <!-- Button -->
                  <v-btn icon class="playBtn" @click="launchGame(hotGames, false)">
                    <v-avatar class="playBtnIcon" :size="$vuetify.breakpoint.mdAndDown ? '48' : '60'">
                      <img src="/static/svg/play_btn.svg" @mouseover="hoverPlayButton($event.currentTarget, true)" @mouseleave="hoverPlayButton($event.currentTarget, false)" alt />
                    </v-avatar>
                  </v-btn>
                </v-overlay>
                <v-overlay v-if="isGameMaintenance(hotGames.type, hotGames.provider)" absolute opacity="0.8" class="gameMaintenanceOverlay">
                  <label class="yellow--text text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
                </v-overlay>
                <img src="/static/image/other/hot-icon.png" class="img-hot-home pos_right_top" />
              </v-img>
            </v-col>
            <v-col cols="12" class="pa-0">
              <span>{{ getGameName(hotGames.locale) }}</span>
            </v-col>
            <v-col cols="12" class="pa-0">
              <span class="rng_providerLabel">{{ $t(`label.hotGames_${hotGames.provider}`).toUpperCase() }}</span>
            </v-col>
          </v-col>
        </v-col>
      </v-row>

      <div id="autoFillEle1" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
        <v-img max-height="0" class="banner-img"></v-img>
      </div>
      <div id="autoFillEle2" class="mobile-provider-card-item gT_homepageHot" style="max-height: 0px !important">
        <v-img max-height="0" class="banner-img"></v-img>
      </div>
    </v-row>
    <!-- desktop view gametype card   -->
    <!--    <v-row class="hidden-sm-and-down" no-gutters justify="space-around">-->
    <!--      <v-col cols="12">-->
    <!--        <v-card class="game-card-menu" style="overflow-x: auto; flex-wrap: nowrap">-->
    <!--          <v-row no-gutters justify="space-around">-->
    <!--            <v-btn-->
    <!--              v-for="(gameType, index) in storageGameProviderType"-->
    <!--              :key="gameType.type"-->
    <!--              @click="selectGameType(gameType, index)"-->
    <!--              class="pt-2 pb-1 px-0 page-navigator-button"-->
    <!--              min-width="45px"-->
    <!--              height="auto"-->
    <!--              text-->
    <!--              :ripple="false"-->
    <!--              light-->
    <!--              depressed-->
    <!--            >-->
    <!--              <v-row no-gutters>-->
    <!--                <v-col cols="12" class="py-0 text-center">-->
    <!--                  <v-divider v-show="gameType.selected" class="game-menu-divider mx-2"></v-divider>-->
    <!--                </v-col>-->
    <!--                <v-col cols="12" class="px-0 pb-1 text-center">-->
    <!--                  <label class="game-menu-title px-2 font-weight-bold">{{ $t(`label.${gameType.type}_short`) }}</label>-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--            </v-btn>-->
    <!--          </v-row>-->
    <!--        </v-card>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <!-- desktop view game providers card   -->
    <!--    <v-row class="mt-0 pt-0 hidden-sm-and-down " justify="space-around">-->
    <!--      <v-col md="6" sm="12" class="pt-0">-->
    <!--        <v-card :class="['game-card-container', lengthOfContainer()]">-->
    <!--          <v-img class="white&#45;&#45;text align-end pa-0" :aspect-ratio="28 / 9"-->
    <!--                 :src="`${mediaUrl}/vendor-banner/${gameContainer1.type}_banner.jpg`"></v-img>-->
    <!--          <v-card-text class="game-card-box">-->
    <!--            <v-row>-->
    <!--              <v-col class="game-card-box-item text-center pa-2" v-for="provider in gameContainer1.providers"-->
    <!--                     :key="provider.providerCode" cols="3">-->
    <!--                <div>-->
    <!--                  &lt;!&ndash; <v-img src="https://cdn.vuetifyjs.com/images/cards/sun.png" alt="Sunny image" width=auto></v-img> &ndash;&gt;-->
    <!--                  &lt;!&ndash; <v-img :src="`${mediaUrl}/vendor-card/${gameContainer1.type}/${provider.providerCode}_avatar.png`" width=auto alt/> &ndash;&gt;-->
    <!--                  <v-img-->
    <!--                    @click="!isGameMaintenance(gameContainer1.type, provider.providerCode) ? accessGame(gameContainer1.type, provider.providerCode) : {}"-->
    <!--                    contain-->
    <!--                    class="game-card-image-avatar"-->
    <!--                    :src="`${mediaUrl}/vendor-card/${gameContainer1.type}/${provider.providerCode}_avatar.png`"-->
    <!--                    :alt="'babu88-' + provider.providerCode"-->
    <!--                    width="auto"-->
    <!--                  >-->
    <!--                    <v-overlay v-if="isGameMaintenance(gameContainer1.type, provider.providerCode)" absolute-->
    <!--                               opacity="0.8" class="gameMaintenanceOverlay">-->
    <!--                      <label class="yellow&#45;&#45;text text-uppercase font-weight-bold">{{-->
    <!--                          $t(`label.underMaintenance`)-->
    <!--                        }}</label>-->
    <!--                    </v-overlay>-->
    <!--                    <img src="/static/image/other/hot-icon.png" class="img-hot-home pos_right_top"-->
    <!--                         v-if="isHotProvider(provider.providerCode)" />-->
    <!--                    <img src="/static/image/other/new_icon.png" class="img-new-home pos_right_top"-->
    <!--                         v-if="isNewProvider(provider.providerCode)" />-->
    <!--                  </v-img>-->
    <!--                  <p class="mt-lg-2">-->
    <!--                    <label class="black&#45;&#45;text text-capitalize text-center holder_text">{{-->
    <!--                        $t(`label.custom_${provider.providerCode}`)-->
    <!--                      }}</label>-->
    <!--                  </p>-->
    <!--                </div>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--          </v-card-text>-->
    <!--        </v-card>-->
    <!--      </v-col>-->
    <!--      <v-col cols="6" class="pt-0">-->
    <!--        <v-card-->
    <!--          :class="[-->
    <!--            'game-card-container',-->
    <!--            gameContainer2.providers.length > 8 || gameContainer1.providers.length > 8 ? 'three' : gameContainer1.providers.length > 4 || gameContainer2.providers.length > 4 ? 'two' : 'one'-->
    <!--          ]"-->
    <!--        >-->
    <!--          <v-img class="white&#45;&#45;text align-end pa-0" :aspect-ratio="28 / 9"-->
    <!--                 :src="`${mediaUrl}/vendor-banner/${gameContainer2.type}_banner.jpg`"></v-img>-->
    <!--          <v-card-text class="game-card-box">-->
    <!--            <v-row align="center">-->
    <!--              <v-col class="game-card-box-item text-center pa-2" v-for="provider in gameContainer2.providers"-->
    <!--                     :key="provider.providerCode" cols="3">-->
    <!--                <div>-->
    <!--                  &lt;!&ndash;                  <v-img class="game-card-image-avatar" v-if="gameContainer2.type == 'fishing'"&ndash;&gt;-->
    <!--                  &lt;!&ndash;                         src="https://cdn.vuetifyjs.com/images/cards/sun.png" alt="babu88" width=auto></v-img>&ndash;&gt;-->
    <!--                  <v-img-->
    <!--                    @click="!isGameMaintenance(gameContainer2.type, provider.providerCode) ? accessGame(gameContainer2.type, provider.providerCode) : {}"-->
    <!--                    class="game-card-image-avatar"-->
    <!--                    :src="`${mediaUrl}/vendor-card/${gameContainer2.type}/${provider.providerCode}_avatar.png`"-->
    <!--                    :alt="'babu88-' + provider.providerCode"-->
    <!--                    width="auto"-->
    <!--                  >-->
    <!--                    <v-overlay v-if="isGameMaintenance(gameContainer2.type, provider.providerCode)" absolute-->
    <!--                               opacity="0.8" class="gameMaintenanceOverlay">-->
    <!--                      <label class="yellow&#45;&#45;text text-uppercase font-weight-bold">{{-->
    <!--                          $t(`label.underMaintenance`)-->
    <!--                        }}</label>-->
    <!--                    </v-overlay>-->
    <!--                    <img src="/static/image/other/hot-icon.png" class="img-hot-home pos_right_top"-->
    <!--                         v-if="isHotProvider(provider.providerCode)" />-->
    <!--                    <img src="/static/image/other/new_icon.png" class="img-new-home pos_right_top"-->
    <!--                         v-if="isNewProvider(provider.providerCode)" />-->
    <!--                  </v-img>-->
    <!--                  <p class="mt-lg-2">-->
    <!--                    <label class="black&#45;&#45;text text-capitalize text-center holder_text">{{-->
    <!--                        $t(`label.custom_${provider.providerCode}`)-->
    <!--                      }}</label>-->
    <!--                  </p>-->
    <!--                </div>-->
    <!--              </v-col>-->
    <!--              &lt;!&ndash; <v-col class="game-card-box-item" v-for="provider in 6" :key="provider" cols="3">-->
    <!--                      <div>-->
    <!--                          <v-img src="https://cdn.vuetifyjs.com/images/cards/sun.png" alt="Sunny image" width=auto></v-img>-->
    <!--                          <v-img :aspect-ratio="311/234" class="game-card-image-avatar"-->
    <!--                     :src="`${mediaUrl}/vendor-card/${gameContainer2.type}/${provider.providerCode}_avatar.png`"-->
    <!--                     alt/>-->
    <!--                      </div>-->
    <!--                  </v-col> &ndash;&gt;-->
    <!--            </v-row>-->
    <!--          </v-card-text>-->
    <!--        </v-card>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
  </div>
</template>

<script>
import _ from 'lodash'
import { uiHelper } from '@/util'
import { CACHE_KEY } from '@/constants/constants'
import { ROUTE_NAME } from '@/constants/route.constants'
import { DevicePlatform } from '@/constants/enums'
import { SHARED } from '@/constants/constants'
import { SEMI_TRANSFER } from '@/store/transfer.module'
import { GAME_HOMEPAGE_HOT, GAME_PROVIDERS_TYPE_CONFIG, JACKPOT_AMOUNT, JACKPOT_GAME, GAME_HOMEPAGE_FEATURED } from '@/store/game.module'

export default {
  name: 'appGameCard',
  // props: {
  //     selectionNavigator: {
  //         type: String,
  //         required: true,
  //         default: 'all'
  //     },
  //     openLoginDialog: {
  //         type: Function,
  //         required: true,
  //         default: () => {}
  //     },
  //     gameType: {
  //         type: String,
  //         required: true,
  //         default: () => ''
  //     }
  // },
  data: () => ({
    currentCurrency: uiHelper.getCurrency(),
    lastTime: 0,
    isInitialLoad: true,
    miniJackpot: 0,
    grandJackpot: 0,
    majorJackpot: 0,
    miniRate: 0.06, // Rate per second
    majorRate: 0.9, // Rate per second
    grandRate: 14.0, // Rate per second
    intervalId: null,
    animationFrameId: null, // Store the animation frame ID for canceling
    currentMiniPrize: 0,
    currentMajorPrize: 0,
    currentGrandPrize: 0,
    currency: (uiHelper.getCurrency() || '').toUpperCase(),
    ldAspRatio: 2 / 1,
    sportCricketTableAspRatio: 3 / 1,
    cricketAspRatio: 617 / 780,
    tableAspRatio: 617 / 780,
    slotAspRatio: 617 / 780,
    crashAspRatio: 617 / 780,
    fastgamesAspRatio: 617 / 780,
    fishingAspRatio: 617 / 780,
    sportsAspRatio: 617 / 780,
    routeName: ROUTE_NAME,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`) || [],
    storageHomepageHotGames: uiHelper.getLocalStorage(`${CACHE_KEY.HOMEPAGE_HOTGAMELIST}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`) || [],
    storageHomepageFeaturedGames: uiHelper.getLocalStorage(`${CACHE_KEY.HOMEPAGE_FEATUREDGAMELIST}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`) || [],
    storageJackpotGames: uiHelper.getLocalStorage(`${CACHE_KEY.JACKPOT_GAMELIST}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`) || [],
    selectedGameCard: '',
    gameContainer1: {},
    gameContainer2: {},
    dActiveGameType: 'ld',
    HomePageHotString: 'homepageHot',
    HomePageFeaturedString: 'homepageFeatured',
    JackPotGames: 'jackpotGames',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  }),
  computed: {
    miniPrize() {
      const prizes = this.$store.state.game.prizes
      if (prizes && prizes.data) {
        return prizes.data.slot.mini || 0
      }
      return 0
    },
    grandPrize() {
      const prizes = this.$store.state.game.prizes
      if (prizes && prizes.data) {
        return prizes.data.slot.grand || 0
      }
      return 0
    },
    majorPrize() {
      const prizes = this.$store.state.game.prizes
      if (prizes && prizes.data) {
        return prizes.data.slot.major || 0
      }
      return 0
    },
    BanneAspRatio() {
      let _aspRatio = 1 / 1
      switch (this.dActiveGameType) {
        case 'ld':
          _aspRatio = 617 / 780
          break
        case 'rng':
          _aspRatio = this.slotAspRatio
          break
        case this.HomePageHotString:
          _aspRatio = 1
          break
        case 'cricket':
          _aspRatio = this.cricketAspRatio
          break
        case 'table':
          _aspRatio = this.tableAspRatio
          break
        case 'sb':
          _aspRatio = this.sportsAspRatio
          break
        case 'fishing':
          _aspRatio = this.fishingAspRatio
          break
        case 'lottery':
          _aspRatio = 1200 / 400
          break
        case 'crash':
          _aspRatio = this.crashAspRatio
          break
        case 'fastgames':
          _aspRatio = this.fastgamesAspRatio
          break
        case this.HomePageFeaturedString:
          _aspRatio = 1
          break
      }
      return _aspRatio
    },
    ActiveMobileGameType() {
      return this.dActiveGameType
    },
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    },
    jackpotPrize() {
      const prizes = this.$store.state.game.prizes
      if (prizes && prizes.data) {
        return prizes.data.slot || {}
      }
      return {}
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    calctab() {
      return this.text.replace('Lorem', 'tab2')
    },
    homepageHotGames() {
      return this.$store.state.game.HomepageHotGames
    },
    homepageFeaturedGames() {
      return this.$store.state.game.HomepageFeaturedGames
    },
    jackpotGamesStg() {
      return this.$store.state.game.jackpotGames
    },
  },
  watch: {
    miniPrize(newValue) {
      if (newValue !== this.currentMiniPrize || newValue !== this.miniJackpot) {
        this.miniJackpot = newValue
        this.currentMiniPrize = newValue
        localStorage.setItem('miniPrize', this.currentMiniPrize)
        this.resetMiniJackpotAnimation()
      }
    },
    grandPrize(newValue) {
      if (newValue !== this.currentGrandPrize || newValue !== this.majorJackpot) {
        this.grandJackpot = newValue
        this.currentGrandPrize = newValue
        localStorage.setItem('grandPrize', this.currentGrandPrize)
        this.resetGrandJackpotAnimation()
      }
    },
    majorPrize(newValue) {
      if (newValue !== this.currentMajorPrize || newValue !== this.majorJackpot) {
        this.majorJackpot = newValue
        this.currentMajorPrize = newValue
        localStorage.setItem('majorPrize', this.currentMajorPrize)
        this.resetMajorJackpotAnimation()
      }
    },
    jackpotPrize() {
      if (this.$store.state.game.prizes === null) {
        this.getJackpotAmount()
      }
      return this.$store.state.game.prizes.data
    },
    ProviderTypes() {
      this.storageGameProviderType = this.$store.state.game.ProviderTypes || []

      if (this.dActiveGameType === 'homepageHot' || this.dActiveGameType === 'homepageFeatured') return

      if (this.currentCurrency.toUpperCase() == 'BDT') {
        this.selectGameType('jackpotGames', -2)
      } else {
        this.selectGameType('', 0)
      }
    },
    ActiveMobileGameType() {
      return this.dActiveGameType
    },
    homepageHotGames() {
      this.storageHomepageHotGames = this.$store.state.game.HomepageHotGames
    },
    homepageFeaturedGames() {

      console.log('ffff = ', this.$store.state.game.HomepageFeaturedGames)
      this.storageHomepageFeaturedGames = this.$store.state.game.HomepageFeaturedGames
    },
    jackpotGamesStg() {
      this.storageJackpotGames = this.$store.state.game.jackpotGames
    },
  },
  created() {
    if (this.$vuetify.breakpoint.mdAndDown && this.currentCurrency && this.currentCurrency.toUpperCase() == 'BDT') {
      this.selectGameType('jackpotGames', -2)
    } else {
      this.selectGameType('', 0)
    }

    this.getHomepageHotGames()
    this.getHomepageFeaturedGames()
    this.getJackpotGames()
  },
  destroyed() {
    clearInterval(this.intervalId)
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
  },
  mounted() {
    const savedMiniPrize = localStorage.getItem('miniPrize')
    const savedMajorPrize = localStorage.getItem('majorPrize')
    const savedGrandPrize = localStorage.getItem('grandPrize')

    if (savedMiniPrize) {
      this.currentMiniPrize = parseFloat(savedMiniPrize)
      this.miniJackpot = this.currentMiniPrize
    }

    if (savedMajorPrize) {
      this.currentMajorPrize = parseFloat(savedMajorPrize)
      this.majorJackpot = this.currentMajorPrize
    }

    if (savedGrandPrize) {
      this.currentGrandPrize = parseFloat(savedGrandPrize)
      this.grandJackpot = this.currentGrandPrize
    }
    this.isInitialLoad = true
    this.getJackpotAmount()
    this.initializeJackpots()
    this.intervalId = setInterval(() => {
      this.getJackpotAmount() // Fetch jackpot data at intervals
    }, 300000) // 5 minutes interval
  },
  methods: {
    startJackpotAnimation(timestamp) {
      // Calculate the time difference from the last update
      const deltaTime = timestamp - this.lastTime
      this.lastTime = timestamp

      // Update jackpot values based on the rates
      this.miniJackpot += (this.miniRate * deltaTime) / 1000 // deltaTime in ms
      this.majorJackpot += (this.majorRate * deltaTime) / 1000
      this.grandJackpot += (this.grandRate * deltaTime) / 1000

      // Continue the animation loop
      this.animationFrameId = window.requestAnimationFrame(this.startJackpotAnimation)
    },
    resetMiniJackpotAnimation() {
      this.miniJackpot = this.currentMiniPrize
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
      }
      this.animationFrameId = window.requestAnimationFrame(this.startJackpotAnimation) // Start animation
    },
    resetMajorJackpotAnimation() {
      this.majorJackpot = this.currentMajorPrize
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
      }
      this.animationFrameId = window.requestAnimationFrame(this.startJackpotAnimation) // Start animation
    },
    resetGrandJackpotAnimation() {
      this.grandJackpot = this.currentGrandPrize
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
      }
      this.animationFrameId = window.requestAnimationFrame(this.startJackpotAnimation) // Start animation
    },
    initializeJackpots() {
      window.requestAnimationFrame(this.startJackpotAnimation) // Start animation after data is fetched
    },
    animateValue(jackpotKey, targetValue) {
      const currentValue = this[jackpotKey]
      const duration = 295000 // 5 minutes (in milliseconds)
      let startTimestamp = null

      // Calculate the difference between current and target values
      const difference = targetValue - currentValue // Don't use Math.abs() here

      // RequestAnimationFrame step function
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp // Initialize start time

        // Calculate progress from 0 to 1 (based on elapsed time)
        const progress = Math.min((timestamp - startTimestamp) / duration, 1)

        // Dynamically calculate the increment per frame
        const dynamicStepValue = difference * progress // This handles both increasing and decreasing

        // Update the current value based on the dynamic increment
        this[jackpotKey] = currentValue + dynamicStepValue

        // Continue the animation until we reach the target value
        if (progress < 1) {
          window.requestAnimationFrame(step) // Request the next frame
        } else {
          // Ensure the final value is set correctly (edge case to avoid overshoot)
          this[jackpotKey] = targetValue
        }
      }

      // Start the animation
      window.requestAnimationFrame(step)
    },
    navigateToJiliSLot() {
      this.$router.push({
        name: ROUTE_NAME.SLOT_BY_PROVIDER,
        params: {
          provider: 'jili',
          lang: this.$route.params.lang,
        },
      })
    },
    getJackpotAmount() {
      this.$store.dispatch(`${JACKPOT_AMOUNT}`)
    },
    hoverPlayButton(element, mouseOver) {
      if (mouseOver) {
        element.src = '/static/svg/play_btn_hover.svg'
      } else {
        element.src = '/static/svg/play_btn.svg'
      }
    },
    hoverDemoButton(element, mouseOver) {
      if (mouseOver) {
        element.src = '/static/svg/demo_btn_hover.svg'
      } else {
        element.src = '/static/svg/demo_btn.svg'
      }
    },
    getGameName(gameLocale) {
      try {
        console.log(gameLocale.find((x) => x.language == 'en').name)
        return gameLocale.find((x) => x.language == this.currentLanguage).name
      } catch (error) {
        console.log(gameLocale.find((x) => x.language == 'en').name)
        return gameLocale.find((x) => x.language == 'en').name
      }
    },
    async directLaunchGame(gameInfo, isDemo) {
      let routeData = this.$router.resolve({
        name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
        params: {
          provider: gameInfo.provider,
          type: gameInfo.type,
          lang: this.$route.params.lang,
        },
        query: {
          id: gameInfo.id,
          code: gameInfo.code,
          demo: isDemo ? 1 : 0,
        },
      })
      try {
        this.$ga.event('Game', `${isDemo ? 'Demo' : 'Real'} Play`, `${gameInfo.provider.toUpperCase()} - Slot - ${gameInfo.locale.find((x) => x.language == 'en').name}`, gameInfo.id)
      } catch (err) {
        console.log(err)
      }
      if (this.providerSelected == 'sb' || this.providerSelected == 'cricket') {
        window.open(routeData.href, '_blank')
        this.semiTransfer(gameInfo.provider)
      } else {
        window.open(routeData.href, '_blank')
        this.semiTransfer(gameInfo.provider).then(() => {})
      }
    },
    launchGame(gameInfo, isDemo) {
      if (!isDemo && !this.isLoggedIn) {
        this.$parent.goToLoginPage()
      } else {
        this.directLaunchGame(gameInfo, isDemo)
      }
      uiHelper.pushSportRadarRetargeting(gameInfo, gameInfo.type, gameInfo.provider)
    },
    getHomepageHotGames() {
      if (!this.storageHomepageHotGames || this.storageHomepageHotGames.length === 0) {
        let obj = {
          currency: uiHelper.getCurrency(),
          platform: uiHelper.getPlatform(),
          size: '',
          page: '',
          mode: 'All',
        }
        this.$store.dispatch(`${GAME_HOMEPAGE_HOT}`, { obj })
      }
    },
    getHomepageFeaturedGames() {
      if (!this.storageHomepageFeaturedGames || this.storageHomepageFeaturedGames.length === 0) {
        let obj = {
          currency: uiHelper.getCurrency(),
          platform: uiHelper.getPlatform(),
          size: '',
          page: '',
          mode: 'All',
        }
        this.$store.dispatch(`${GAME_HOMEPAGE_FEATURED}`, { obj })
      }
    },
    getJackpotGames() {
      if (!this.storageJackpotGames || this.storageJackpotGames.length === 0) {
        let obj = {
          currency: uiHelper.getCurrency(),
          platform: uiHelper.getPlatform(),
          size: '',
          page: '',
          mode: 'All',
        }
        this.$store.dispatch(`${JACKPOT_GAME}`, { obj })
      }
    },
    getGameProviderTypeInfo() {
      let providerTypeConfigObj = {
        currency: uiHelper.getCurrency(),
        platform: uiHelper.getPlatform(),
      }
      this.$store.dispatch(`${GAME_PROVIDERS_TYPE_CONFIG}`, { providerTypeConfigObj })
    },
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER,
        params: { lang: this.$route.params.lang },
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang },
      })
    },
    isNewProvider(provider) {
      let arr = ['aura', 'royal', 'booongo', 'haba', 'nolimit', 'one', 'pg', 'relax', 'netent']
      return arr.indexOf(provider.toLowerCase()) > -1
    },
    isHotProvider(provider) {
      let arr = ['jili', 'evo', 'betswiz', 'pp', 'sexy_v2', 'spg', 'ibc', 'smart', '9wicket']
      return arr.indexOf(provider.toLowerCase()) > -1
    },
    isFeaturedProvider(provider) {
      let arr = ['jili', 'evo', 'betswiz', 'pp', 'sexy_v2', 'spg', 'ibc', 'smart', '9wicket']
      return arr.indexOf(provider.toLowerCase()) > -1
    },
    setActiveGameType(gameType, index) {
      this.dActiveGameType = gameType != undefined ? gameType.type : 'cricket'
    },
    lengthOfContainer() {
      let c1 = this.gameContainer1
      let c2 = this.gameContainer2
      if (c1 != null) {
        return c1.providers.length > 8 ? 'three' : c1.providers.length > 4 ? 'two' : 'one'
        if (c2 != null) {
          return c2.providers.length > 8 ? 'three' : c2.providers.length > 4 ? 'two' : 'one'
        }
      }
      return 'one'
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    tabfunc() {
      let t = this.tab.split('-')
      let index = parseInt(t[1]) + 1
      this.tab2 = 'tab-' + index
      console.log(this.tab2)
      console.log(this.tab)
    },
    selectGameType(gameType, index) {
      if (gameType === 'jackpotGames' && index === -2) {
        this.dActiveGameType = 'jackpotGames'
      } else if (gameType === 'homepageFeatured' && index === -3) {
        this.dActiveGameType = 'homepageFeatured'
      } else {
        this.dActiveGameType = gameType != '' && gameType != undefined ? gameType.type : 'homepageHot'
      }
      if ((gameType === '' && index === -1) || (gameType === 'jackpotGames' && index === -2) || (gameType === 'homepageFeatured' && index === -3)) return

      if (this.storageGameProviderType) {
        if (this.storageGameProviderType.length === 0) return
        if (this.$vuetify.breakpoint.mdAndUp) {
          if (index + 1 < this.storageGameProviderType.length) {
            this.gameContainer1 = this.storageGameProviderType[index]
            this.gameContainer2 = this.storageGameProviderType[index + 1]
          } else {
            this.gameContainer1 = this.storageGameProviderType[index - 1]
            this.gameContainer2 = this.storageGameProviderType[index]
          }
          _.forEach(this.storageGameProviderType, function (gameType) {
            gameType.selected = false
          })
          this.gameContainer1.selected = true
          this.gameContainer2.selected = true
        } else {
          this.gameContainer1 = this.storageGameProviderType[index]
          this.gameContainer2 = this.storageGameProviderType[index]
          _.forEach(this.storageGameProviderType, function (gameType) {
            gameType.selected = false
          })
          this.gameContainer1.selected = true
        }
      } else {
        this.getGameProviderTypeInfo()
      }
    },
    isGameMaintenance(gameType, providerCode) {
      if (
        this.storageGameProviderType == null ||
        this.storageGameProviderType.find((x) => x.type == gameType) == undefined ||
        this.storageGameProviderType.find((x) => x.type == gameType).providers.find((x) => x.providerCode == providerCode) == undefined
      ) {
        return false
      } else {
        return this.storageGameProviderType.find((x) => x.type == gameType).providers.find((x) => x.providerCode == providerCode).isMaintenance
      }
    },
    async accessGame(type, providerCode) {
      let gaType = ''
      switch (type) {
        case 'sb':
          gaType = 'Sportsbook'
          break
        case 'ld':
          gaType = 'Casino'
          break
        case 'special':
          gaType = 'Special'
          break
        case 'crash':
          gaType = 'Crash'
          break
        case 'fastgames':
          gaType = 'Fastgames'
          break
      }
      // if (!this.isLoggedIn && uiHelper.getPlatform() == DevicePlatform.MOBILE && type != 'rng' && type != 'special') {
      //     this.openLoginDialog()
      // }
      // else {
      if (type == 'rng') {
        this.$router.push({
          name: ROUTE_NAME.SLOT_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else if (type == 'fishing') {
        this.$router.push({
          name: ROUTE_NAME.FISHING_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else if (type == 'lottery') {
        this.$router.push({
          name: ROUTE_NAME.LOTTERY_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else if (type == 'table') {
        this.$router.push({
          name: ROUTE_NAME.TABLE_GAMES_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else if (type == 'special') {
        this.$router.push({
          name: ROUTE_NAME.SPECIAL_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else if (type == 'crash') {
        this.$router.push({
          name: ROUTE_NAME.CRASH_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else if (type == 'fastgames') {
        this.$router.push({
          name: ROUTE_NAME.FAST_GAMES_BY_PROVIDER,
          params: {
            provider: providerCode,
            lang: this.$route.params.lang,
          },
        })
      } else {
        if (this.isLoggedIn) {
          let routeData = this.$router.resolve({
            name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
            params: {
              provider: providerCode,
              lang: this.$route.params.lang,
              type: type,
            },
            query: {
              demo: 0,
            },
          })
          try {
            this.$ga.event('Game', 'Real Play', `${providerCode.toUpperCase()} - ${gaType}`)
          } catch (err) {
            console.log(err)
          }
          if (type == 'sb' || type == 'cricket') {
            await uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
            this.semiTransfer(providerCode)
          } else {
            this.semiTransfer(providerCode).then(() => {
              uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
            })
          }
          uiHelper.pushSportRadarRetargeting(null, type, providerCode)
        } else {
          this.goToLoginPage()
        }
      }
      //}
    },
    semiTransfer(providerCode) {
      let obj = {
        to_wallet: providerCode,
      }
      return this.$store.dispatch(`${SEMI_TRANSFER}`, { obj })
    },
  },
}
</script>

<style lang="scss">
.jackpotImg-padding {
  //padding: 0 11px !important;
}

.grandText {
  padding-top: 12%;
}
.majorText,
.miniText {
  padding-top: 12%;
  font-size: 14px;
}
.imgBox .v-responsive__content {
  align-items: center;
  justify-content: center;
  display: flex;
}
.jackpot_container {
  position: absolute;
  bottom: 10%;
  width: 100%;
}
.game-menu-row {
  background-color: #f5f5f5 !important;
  border-radius: 25px 0px 0px 25px;
}

.game-menu-button {
  &.selected {
    color: #000000;
    opacity: 1;
    background: var(--v-newMobilePrimary-base) !important;

    .game-menu-image {
      background-color: #000000;
    }
  }
}

.game-menu-button.v-card::before {
  background: transparent !important;
}

.game-menu-button.v-card:focus {
  outline: none !important;
  box-shadow: none !important;
}

.game-menu-button.v-card:active::before {
  background: transparent !important;
}

.game-menu-button {
  box-shadow: none !important;
  border-radius: 20px !important;
  background-color: transparent !important;
  margin: 0 2px 3px 0px;
  width: 80px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;

  .v-btn__content {
    display: flex;
    flex-direction: column;
  }

  .game-menu-image {
    background-color: #000;
    -webkit-mask-image: var(--src);
    mask-image: var(--src);
    -webkit-mask-size: 100%;
    mask-size: 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    width: 22px;
    height: 22px;
    margin-left: 0px;
    margin-right: 4px;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }
}

.playBtn {
  opacity: 0;
}
.game-banner-img:hover .play-overlay {
  //display: block;
  background-color: rgba(255, 255, 255, 0.65);
}
.game-banner-img:hover .playBtn {
  opacity: 1;
}
.title_hotGameDesktop {
  font-size: 25px;
}
.img-hot-home {
  width: 35px;
  animation: beat 1s infinite alternate;
}

.img-new-home {
  width: 35px;
  top: 7px;
  animation: beat 1s infinite alternate;
}

.pos_right_top {
  position: absolute !important;
  right: 4px;
  top: 5px;
}

.mobile-provider-card-row {
  justify-content: space-between;

  .v-image__image {
    //background-size: 100% 100%;
  }

  &.rng-warpper {
    gap: 0.5rem;
  }

  .rng_providerLabel {
    font-size: 0.7rem;
  }
}

.mobile-provider-card-row.game-warpper {
  justify-content: flex-start;
  gap: 0.5rem;
}

@media (max-width: 480px) {
  .mobile-provider-card-row.game-warpper {
    gap: 0.25rem;
  }
}

@media (max-width: 375px) {
  .mobile-provider-card-row.game-warpper {
    gap: 0.15rem;
  }
}

.ld-gap {
  gap: 0.5rem 0;
  padding-top: 12px;
}

.left-right-gap {
  gap: 0.5rem 0.5rem;
}

.game-banner-img {
  border-radius: 10px;
}
.desktop-provider-card-item {
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: start;
  padding-bottom: 1%;
  //margin-bottom: 20px;
  border-radius: 10px !important;
  //2 cols
  &.gT_homepageHot {
    min-width: 20%;
    max-width: 20%;
    height: 10%;
    flex-direction: column;
    padding: unset;
  }

  &.gT_ld {
    min-width: 47vw;
    max-width: 47vw;
    padding: 0 5px 5px 0 !important;
    height: auto !important;
  }

  //4 cols
  &.gT_rng {
    min-width: 22vw;
    max-width: 22vw;
    height: auto !important;
    flex-direction: column;
    padding: unset;
  }

  &.gT_crash {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    flex-direction: column;
    padding: unset;
  }

  &.gT_fastgames {
    min-width: 22vw;
    max-width: 22vw;
    height: auto !important;
    flex-direction: column;
    padding: unset;
  }

  //single col
  &.gT_cricket {
    height: auto !important;
    min-width: 90vw;
    //height: 90px;
  }

  &.gT_sb {
    min-width: 90vw;
    height: auto !important;
    //height: 90px;
  }

  &.gT_table {
    min-width: 47vw;
    max-width: 47vw;
    padding: 0 5px 5px 0 !important;
    height: auto !important;
  }

  &.gT_fishing {
    min-width: 90vw;
    height: auto !important;
  }

  &.gT_lottery {
    min-width: 90vw;
    height: auto !important;
  }

  .sqrBox_img {
    height: 110px;
    width: 100%;
  }

  .homepageHot_img {
    aspect-ratio: 3 / 1.9;
    object-fit: cover;
    display: block;
  }
}

.new-gametab-padding {
  padding-top: 16px;
  justify-content: space-evenly;
}
.mobile-provider-card-item {
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin-bottom: 20px;
  border-radius: 10px !important;
  //2 cols
  &.gT_homepageHot {
    min-width: 31.5vw;
    max-width: 30vw;
    height: auto !important;
    flex-direction: column;
    padding: unset;
  }

  &.gT_ld {
    flex: 0 0 calc(25% - 6px);
    max-width: calc(25% - 6px);
    padding: 0px !important;
    height: auto !important;
  }

  //4 cols
  &.gT_rng {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  &.gT_crash {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  &.gT_fastgames {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  //single col
  &.gT_cricket {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  &.gT_sb {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  &.gT_table {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  &.gT_fishing {
    min-width: 23vw;
    max-width: 23vw;
    height: auto !important;
    padding: 0px !important;
  }

  &.gT_lottery {
    min-width: 22vw;
    max-width: 22vw;
    height: auto !important;
    padding: 0 5px 5px 0 !important;
  }

  .sqrBox_img {
    //height: 110px;
    width: 100%;
    border-radius: 10px !important;
  }

  .homepageHot_img {
    height: auto;
    width: 100%;
  }
}

.game-menu {
  .div-gameTypeCard-wrapper {
  }

  .game-menu-wrapper {
    max-width: 1240px;
    white-space: nowrap;
    overflow: auto;
    display: flex;
    overflow-y: hidden;
    align-items: center;
    background-color: var(--v-text-base);
    margin: 10px -6px 10px 0;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: space-evenly;
  }

  .game-menu-content {
    min-width: 85px;
    width: 88px;
    height: 88px;
    text-transform: capitalize;
    padding: 10px 0px !important;
    background-color: #333333;
    color: #ffffff;
    margin: 0 10px 3px 0px;

    .v-btn__content {
      display: flex;
      flex-direction: column;
    }

    //.game-menu-image {
    //  margin-left: 8px;
    //  width: 40px;
    //  height: 40px;
    //}
    .game-menu-image {
      background-color: #ffffff;
      -webkit-mask-image: var(--src);
      mask-image: var(--src);
      -webkit-mask-size: 100%;
      mask-size: 100%;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      width: 40px;
      height: 45px;
      margin-left: 8px;
    }

    .game-menu-title {
      margin-top: 8px;
      font-size: 12px;
      margin-left: 8px;
    }
  }
}

.game-menu {
  .v-btn {
    border-radius: unset;
  }

  .game-menu-content {
    &.selected {
      color: #000000;
      opacity: 1;
      background: var(--v-newMobilePrimary-base);

      .game-menu-image {
        background-color: #000000;
      }
    }
  }
}

.underline_bar {
  opacity: 0;
}

.game-card-menu {
  max-height: 80px;
  border-radius: 20px !important;

  .game-menu-title {
    font-size: 24px;
    text-transform: capitalize;

    &:hover {
      color: #0c2aab;
    }
  }

  .game-menu-divider {
    border: 2px solid #fddd04;
  }
}

.game-banner-text {
  font-size: 28px;

  p span {
    display: block;
  }
}

.game-card-container {
  //max-height: 530px;
  min-height: auto;
  max-height: max-content;
  border-radius: 20px !important;
}

.game-card-banner {
  height: 250px;
}

.icon_gameCard {
  fill: white;
  color: black;
  stroke: #9c9ff3;
  width: 30px;
  height: 33px;
  padding-top: 4px;
}

.home_slot_text {
  color: #9c9ff3;
  float: left;
  font-size: 26px !important;
}

.row_slots {
  position: relative;
}

.row_slots img {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.card-hidden {
  display: none;
}

.game-card-box-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;
}

.holder_text {
  font-size: 18px;
  display: block;
  line-height: 2;
}

.game-card-box {
  min-height: 452px;

  .game-card-box-item {
    cursor: pointer;
    display: inline-block;
    min-width: 105px;
    min-height: 105px;
    .game-card-image-avatar {
      border-radius: 10px;
      border: 1px solid transparent;

      .gameMaintenanceOverlay {
        border-radius: 20px;
      }
    }
  }

  .game-card-box-item:hover {
    .game-card-image-avatar {
      border: 5px solid #fddd04;
      border-radius: 30px;
    }
  }

  // .game-card-box-item:hover {
  //     .game-card-image-avatar {
  //         opacity: 0.4;
  //     }
  //     .vendor-info {
  //         opacity: 1;
  //         height: auto;
  //         width: auto;
  //         position: absolute;
  //         top: 50%;
  //         left: 50%;
  //         transform: translate(-50%, -50%);
  //     }
  //     .vendor-title {
  //         background: -webkit-linear-gradient(#FFA15C, #EDD763);
  //         -webkit-background-clip: text;
  //         -webkit-text-fill-color: transparent;
  //         text-shadow: 3px 3px 3px #FFFFFF;
  //     }
  // }
}

@media (max-width: 2560px) {
  .game-card-container {
    //max-height: 720px;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }

  .game-card-container.three {
    //min-height: 1400px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 1080px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 1920px) {
  .game-card-box {
    min-height: 460px;
  }
  .game-card-container {
    //max-height: 540px;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }
  .game-card-container.three {
    //min-height: 1080px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 820px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 1650px) {
  .game-card-box {
    min-height: 430px;
  }
  .game-card-container {
    //max-height: 490px;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }
  .game-card-container.three {
    //min-height: 900px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 710px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 1500px) {
  .game-card-box {
    min-height: 380px;
  }
  .game-card-container {
    //max-height: 430px;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }
  .game-card-container.three {
    //min-height: 850px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 660px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 1350px) {
  .game-card-box {
    min-height: 300px;
  }
  .game-card-container {
    //max-height: 360px;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }
  .game-card-container.three {
    //min-height: 800px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 610px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 1280px) {
  .desktop-provider-card-item .homepageHot_img {
    max-height: 125px;
  }
  .game-card-box {
    min-height: 300px;
  }
  .game-card-container {
    //max-height: 360px;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }

  .game-card-container.three {
    //min-height: 750px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 580px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 1024px) {
  .desktop-provider-card-item .homepageHot_img {
    max-height: 100px;
  }
  .game-card-box {
    min-height: 280px;
  }
  .game-card-container {
    //max-height: fit-content;
    min-height: auto;
    max-height: max-content;
    border-radius: 20px !important;
  }
  .game-card-container.three {
    //min-height: 450px;
    min-height: auto;
    max-height: max-content;
  }

  .game-card-container.two {
    //min-height: 380px;
    min-height: auto;
    max-height: max-content;
  }
}

@media (max-width: 959px) {
  .holder_text {
    font-size: 12px;
  }
  .game-card-banner {
    height: 120px;
  }
  .game-banner-text {
    font-size: 16px;
  }
  .game-card-box {
    min-height: 120px;

    .game-card-box-item {
      display: inline-block;
      min-width: 54px;
      min-height: 54px;
    }
  }
  .game-card-menu {
    max-height: 80px;
    border-radius: 20px !important;

    .game-menu-title {
      font-size: 14px;
      text-transform: capitalize;

      &:hover {
        color: #0c2aab;
      }
    }

    .game-menu-divider {
      border: 2px solid #fddd04;
    }
  }
}

@media (max-width: 699px) {
  .game-menu-wrapper {
    .game-menu-content {
      min-width: 70px !important;
      width: 70px !important;
      height: 73px !important;

      .game-menu-image {
        width: 35px !important;
        height: 39px !important;
      }

      .game-menu-title {
        margin-top: 3px !important;
      }
    }
  }
}

@media (max-width: 599px) {
  .pos_right_top {
    right: 3px;
    top: 3px;
  }

  .img-hot-home {
    width: 22px;
  }

  .img-new-home {
    width: 25px;
  }

  .holder_text {
    font-size: 8px;
  }
  .game-card-banner {
    height: 90px;
  }
  .game-banner-text {
    font-size: 16px;
  }
  .game-card-box {
    min-height: 100px;

    .game-card-box-item {
      display: inline-block;
      min-width: 54px;
      min-height: 54px;
      max-height: 140px;
    }
  }

  .game-menu-title {
    font-size: 10px !important;

    &:hover {
      color: #0c2aab;
    }
  }

  .game-card-menu {
    max-height: 80px;
    border-radius: 10px !important;

    .game-menu-divider {
      border: 2px solid #fddd04;
    }
  }
}

@media (max-width: 499px) {
  .game-card-box {
    .game-card-box-item {
      max-height: 103px;
    }
  }
}

@keyframes beat {
  to {
    transform: scale(1.15);
  }
}
</style>
